<template>
  <OmtLayoutContainer>
    <OmtRow>
      <OmtTypography
        mb="16px"
        as="h1-bold"
        color="var(--colors-priary-gray)"
      >
        O que pode ser enviado para reavaliação da Ouvidoria?
      </OmtTypography>
    </OmtRow>
    <OmtRow mt="16px">
      <OmtTypography
        as="p1"
        color="var(--colors-light-primary-gray1)"
      >
        Você pode solicitar à Ouvidoria a revisão de
        <strong> reclamações já respondidas pela Central de Atendimento,</strong>
        caso não esteja satisfeito com a solução.
      </OmtTypography>
    </OmtRow>
    <OmtRow
      mt="16px"
      mb="24px"
    >
      <OmtTypography
        as="p1"
        color="var(--colors-light-primary-gray)"
      >
        Para isso, é importante informar o que não concorda na resposta, incluir novas evidências e detalhar sua
        expectativa após a revisão.
      </OmtTypography>
    </OmtRow>
    <OmtRow
      border-radius="8px"
      padding="16px"
      bg="var(--colors-light-primary-light-gray)"
      flex-direction="column"
    >
      <CFlex>
        <OmtIcons
          name="clipboard-list-check"
          mr="16px"
        />
        <OmtTypography
          as="h2-bold"
          color="var(--colors-light-primary-gray)"
          >Como solicitar a revisão</OmtTypography
        >
      </CFlex>
      <OmtRow mt="12px">
        <OmtTypography
          as="p1"
          color="var(--colors-light-primary-gray)"
        >
          1. Informe o número do protocolo da sua reclamação na Central de Atendimento.
        </OmtTypography>
      </OmtRow>
      <OmtRow my="8px">
        <OmtTypography
          as="p1"
          color="var(--colors-light-primary-gray)"
        >
          2. Explique claramente os motivos para a revisão.
        </OmtTypography>
      </OmtRow>
      <OmtRow>
        <OmtTypography
          as="p1"
          color="var(--colors-light-primary-gray)"
        >
          3. Diga o que espera como resultado da reavaliação.
        </OmtTypography>
      </OmtRow>
    </OmtRow>
    <OmtRow
      mt="48px"
      justifyContent="center"
    >
      <CStack :align="'center'">
        <OmtButton
          :w="['100%', '342px !important']"
          @click="goToNextPage"
          >Continuar</OmtButton
        >
      </CStack>
    </OmtRow>
  </OmtLayoutContainer>
</template>

<script>
import omtButton from "@/components/Atoms/omt-button.vue";

export default {
  name: "TermoOuvidoria",
  components: {
    omtButton
  },
  data() {
    return {};
  },
  computed: {},
  async mounted() {
    this.$root.$emit("hide-loading");
  },
  methods: {
    goToNextPage() {
      this.$router.push("/ouvidoria/criar/protocolo");
    }
  }
};
</script>

<style scoped>
.terms {
  color: var(--colors-light-primary-navy-blue);
  cursor: pointer;
}
</style>
